"use strict";

/**
 *  @desc 正则库
 *  @create 2016-1-9
 *  @author wangkuan
 */
module.exports = {
  /**
   * 是否是整数
   */
  isInteger: function isInteger(value) {
    return (/^\d$/.test(value)
    );
  },

  /**
   * 是否是小数
   */
  isFloat: function isFloat(value) {
    return (/^[0-9]+([.]{1}[0-9]+){0,1}$/.test(value)
    );
  },

  /**
   * 是否是手机号
   */
  isPhone: function isPhone(value) {
    return (/^1\d{10}$/.test(value)
    );
  },

  /**
   * 是否是邮箱
   */
  isEmail: function isEmail(value) {
    return (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)
    );
  },

  /**
   * 是否是https的url
   */
  isHttps: function isHttps(value) {
    return (/^http:\/\/*/.test(value)
    );
  },

  /**
   * 是否为身份证号（中国的）
   */
  isIdCard: function isIdCard(value) {
    return (/^\d{15}$|^\d{18}$|^\d{17}(\d|X|x)$/.test(value)
    );
  },

  /**
   * 是否为社会信用代码
   */
  isCreditCode: function isCreditCode(value) {
    return (/[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g.test(value)
    );
  },

  /**
   * 密码强度校验(8-16位，包含数字、字母)
   */
  passwordSafe: function passwordSafe(value) {
    return (/^(?![^a-zA-Z]+$)(?!\D+$).{8,16}$/g.test(value)
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-util/lib/regexp.js
// module id = 1Ez/
// module chunks = 11